var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 0.5H38.5566C48.1083 0.50015 55.8514 8.24326 55.8516 17.7949V38.5566C55.8514 48.1083 48.1083 55.8514 38.5566 55.8516H17.7949C8.24326 55.8514 0.500151 48.1083 0.5 38.5566V17.7949C0.500174 8.24328 8.24328 0.500174 17.7949 0.5Z",
    fill: "url(#paint0_linear_154_4183)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 0.5H38.5566C48.1083 0.50015 55.8514 8.24326 55.8516 17.7949V38.5566C55.8514 48.1083 48.1083 55.8514 38.5566 55.8516H17.7949C8.24326 55.8514 0.500151 48.1083 0.5 38.5566V17.7949C0.500174 8.24328 8.24328 0.500174 17.7949 0.5Z",
    fill: "#1B1B1B",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 0.5H38.5566C48.1083 0.50015 55.8514 8.24326 55.8516 17.7949V38.5566C55.8514 48.1083 48.1083 55.8514 38.5566 55.8516H17.7949C8.24326 55.8514 0.500151 48.1083 0.5 38.5566V17.7949C0.500174 8.24328 8.24328 0.500174 17.7949 0.5Z",
    stroke: "url(#paint1_linear_154_4183)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_4183)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    transform: "translate(9.17578 9.17578)",
    fill: "url(#paint2_linear_154_4183)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    transform: "translate(9.17578 9.17578)",
    fill: "#1B1B1B",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2974 34.4524C39.9601 32.3386 40.8605 29.7511 40.8605 27.0929C40.8605 26.4 40.2796 25.8345 39.568 25.8345C38.8565 25.8345 38.2756 26.4 38.2756 27.0929C38.2756 29.0865 37.6439 31.0307 36.4531 32.6567L38.2974 34.4524Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4258 27.0929V18.687C37.4258 13.8443 33.3742 9.89941 28.3933 9.89941C24.3345 9.90648 20.7766 12.5364 19.6875 16.3399L35.8429 32.07C36.874 30.6065 37.4258 28.8674 37.4258 27.0929Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3596 44.9077L11.7688 11.2277C11.2606 10.7398 10.4401 10.754 9.93908 11.2489C9.4526 11.7367 9.4526 12.5143 9.93908 13.0092L19.1168 21.9382V28.0535C19.1241 32.9104 23.1611 36.8411 28.1493 36.8482C29.8702 36.8482 31.5547 36.3675 33.0069 35.4626L33.6168 36.0564C31.9976 37.1098 30.0953 37.6683 28.1493 37.6683C22.7037 37.6683 18.2746 33.3558 18.2746 28.0535C18.26 27.3607 17.6646 26.8092 16.9531 26.8234C16.2633 26.8375 15.7042 27.3819 15.6897 28.0535C15.6897 34.3173 20.5908 39.4852 26.8642 40.1215V45.7843C26.8642 46.4771 27.445 47.0427 28.1566 47.0427C28.8682 47.0427 29.449 46.4771 29.449 45.7843V40.1285C31.6273 39.9094 33.7112 39.1317 35.4828 37.8733L44.5299 46.6892C45.0381 47.1841 45.8513 47.1841 46.3596 46.6892C46.8606 46.1943 46.8606 45.3955 46.3596 44.9077Z",
    fill: "#2A2A2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_4183",
    x1: 80.8503,
    y1: -4.39298,
    x2: -5.65921,
    y2: -2.92207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9788AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A285AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#8589AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#9985AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_4183",
    x1: 6.75247,
    y1: -0.00000107404,
    x2: 62.2308,
    y2: 49.8024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3A9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_154_4183",
    x1: 54.5204,
    y1: -2.96235,
    x2: -3.81622,
    y2: -1.97046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9788AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A285AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#8589AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#9985AD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_4183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(9.17578 9.17578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicDisabled);
export default __webpack_public_path__ + "static/media/mic_disabled.4cc1a102f9b3a7baa018abfd1b54f9e4.svg";
export { ForwardRef as ReactComponent };